import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-order-history-customer',
  templateUrl: './order-history-customer.component.html',
  styleUrls: ['./order-history-customer.component.scss']
})
export class OrderHistoryCustomerComponent implements OnInit {
  btn: any = "Pending";
  headingName: any = 'Your Order History';
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    { name: 'Account', route: '/customer-profile' },
    { name: 'Order History', route: '/customer-order-history' }
  ];

  orderList: any = [];
  count: any;
  catName: any;
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING';
  isLoading: boolean = false;
  notFoundData: boolean = false;

  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  constructor(public commonService: CommonService, public router: Router) { }

  ngOnInit(): void {
    // Check if we're coming from a Yoco payment success page
    const fromYoco = localStorage.getItem('from_yoco_payment');
    if (fromYoco === 'true') {
      // Clear the flag
      localStorage.removeItem('from_yoco_payment');
    }
    
    // Always load the order list
    this.serviceOrderList();

    // Setup debounced search input
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(search => {
      this.currentPage = 1;
      this.serviceOrderList();
    });
  }

  // Called on (input) of search field
  onSearchInput(event: any): void {
    const value = event.target.value.trim();
    this.searchTerm = value;
    this.searchSubject.next(value);
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }

  serviceOrderList() {
    this.isLoading = true;
    this.orderList = [];
    this.count = 0;

    const data: any = {
      page: this.currentPage,
      limit: this.pageSize,
      orderType: 'PRODUCT'
      // statusType: this.serviceStatus
    };

    // ⛔️ Don't send search to backend; instead filter below
    // if (this.searchTerm) {
    //   data.search = this.searchTerm;
    // }

    this.commonService.postApi('order/orderListOfOwn', data, 1).subscribe((res: any) => {
      this.isLoading = false;
      this.commonService.hideSpinner();

      if (res['responseCode'] === 200 && res.result.docs.length > 0) {
        let allOrders = res.result.docs;

        // ✅ Perform frontend filtering based on searchTerm
        if (this.searchTerm && this.searchTerm.trim().length > 0) {
          const lowerSearch = this.searchTerm.toLowerCase();

          allOrders = allOrders.filter((order: any) => {
            const productName = order?.productDetails?.[0]?.productId?.productName?.toLowerCase() || '';
            const orderId = order?.orderId?.toLowerCase() || '';
            const deliveryStatus = order?.deliveryStatus?.toLowerCase() || '';
            const orderStatus = order?.orderStatus?.toLowerCase() || '';
            const paymentStatus = order?.paymentStatus?.toLowerCase() || '';

            return (
              productName.includes(lowerSearch) ||
              orderId.includes(lowerSearch) ||
              deliveryStatus.includes(lowerSearch) ||
              orderStatus.includes(lowerSearch) ||
              paymentStatus.includes(lowerSearch)
            );
          });
        }

        this.orderList = allOrders;
        this.count = this.orderList.length;
        this.notFoundData = this.orderList.length === 0;
      } else {
        this.notFoundData = true;
        this.commonService.errorToast(res.responseMessage);
      }
    }, (err: any) => {
      this.notFoundData = true;
      this.isLoading = false;
      if (err.responseCode === 409) {
        this.commonService.hideSpinner();
        this.commonService.errorToast(err.responseMessage);
      }
    });
  }

  changePageNumber(page: number) {
    this.currentPage = page;
    this.serviceOrderList();
  }

  getNoOfquantity(prodArr: any[]): number {
    let noOfQuant = 0;
    for (const item of prodArr) {
      noOfQuant += item.quantity;
    }
    return noOfQuant;
  }
}
